//3rd Party Components
import React, { useState, useEffect } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

//Components
import { stringIsNullOrEmpty } from '../../components/Portal/Utilities';
import AUselect from '@gov.au/select';

const SortedTable = ({ order, caption, subcaption, sortby, data, cols, showIfEmpty, cellStyler, cellClasser, footer, ignoreSortByColumn }) => {
    const [sortOrder, setSortOrder] = useState(order);
    const [sortBy, setSortBy] = useState(sortby);
    const [active, setActive] = useState(sortby);

    let type = cols.find(function (x) {
        if (sortBy && x.property === sortBy) { return x.type } else { return null; }
    })
    const [rowdef, setRowdef] = useState(type);

    useEffect(() => {
        let type = cols.find(function (x) {
            if (sortBy && x.property === sortBy) { return x.type } else { return null; }
        })
        setRowdef(type);
    }, [cols, sortBy]);

    const desc = (a, b, active, rowdef) => {
        if (rowdef.type === "date") {
            if (moment(b[active], "DD MMM YYYY") < moment(a[active], "DD MMM YYYY")) {
                return -1;
            }

            if (moment(b[active], "DD MMM YYYY") > moment(a[active], "DD MMM YYYY")) {
                return 1;
            }

            return 0;
        }
        if (b[active] < a[active]) {
            return -1;
        }

        if (b[active] > a[active]) {
            return 1;
        }

        return 0;
    }

    const stableSort = (array, cmp) => {
        if (sortBy) {
            var stabilizedThis = array.map((el, index) => {
                return [el, index];
            });
            stabilizedThis.sort((a, b) => {
                let order = cmp(a[0], b[0]);
                if (order !== 0) return order;
                return a[1] - b[1];
            });
            return stabilizedThis.map((el) => {
                return el[0];
            });
        }
        return array;
    }

    const getSorting = (order) => {
        return order === 'desc' ? (a, b) => {
            return desc(a, b, active, rowdef);
        } : (a, b) => {
            return -desc(a, b, active, rowdef);
        };
    }

    const handleRequestSort = (property, rowdef) => {
        let neworder = 'desc';

        if (active === property && sortOrder === 'desc') {
            neworder = 'asc';
        }

        setActive(property);
        setRowdef(rowdef);
        setSortBy(property);
        setSortOrder(neworder);
    }

    const colVisible = (index) => {
        return cols[index].visible;
    }

    const cmdHandler = (e, index, colindex, d) => {
        cols[colindex].commandLink(d);
    }

    const setInnerHTML = (value) => {
        return { __html: value };
    };

    const cellRender = (col, colindex, d, index) => {
        let msg = null;
        let msgExtra = null;

        if (col.msgExtra != null) {
            msgExtra = (<span style={{ marginLeft: '.2rem' }}>{d[col.msgExtra]}</span>);
        }

        if (col.hasMsg && d[col.hasMsglevel] === "error") {
            msg = (
                <span>
                    <span style={{ marginLeft: '.2rem' }} className="badge badge-error">{d[col.hasMsg]}</span>
                    <span>{msgExtra}</span>
                </span>
            );
        }

        if (col.hasMsg && d[col.hasMsglevel] === "warning") {
            msg = (
                <span>
                    <span style={{ marginLeft: '.2rem' }} className="badge badge-warning">{d[col.hasMsg]}</span>
                    <span>{msgExtra}</span>
                </span>
            );
        }

        if (col.hasMsg && d[col.hasMsglevel] === "info") {
            msg = (
                <span>
                    <span style={{ marginLeft: '.2rem' }} className="badge badge-in-progress">{d[col.hasMsg]}</span>
                    <span>{msgExtra}</span>
                </span>
            );
        }

        if (col.hasMsg && d[col.hasMsglevel] === "inprogress") {
            msg = (
                <span>
                    <span style={{ marginLeft: '.2rem' }} className="badge badge-in-progress">{d[col.hasMsg]}</span>
                    <span>{msgExtra}</span>
                </span>
            );
        }

        let show = false;
        if (col.commandVisible) {
            show = col.commandVisible(d);
        }
        else {
            show = true;
        }

        let active = true;
        if (col.commandActive) {
            active = col.commandActive(d);
        }

        let commandText;
        let aCommand;

        if (col.commandLink && show) {
            if (col.command) {
                if (active) {
                    commandText = (d[col.command] === undefined ? col.command : d[col.command]);
                    aCommand = (<button type="button" className="btn-link"
                        onClick={function onClick(e) {
                            return cmdHandler(e, index, colindex, d);
                        }}>{commandText}</button>)
                }
                else {
                    commandText = (d[col.command] === undefined ? col.command : d[col.command]);
                    aCommand = <span>{commandText}</span>
                }

                //in case there is a message, display the command on next line :)
                return (!msg ?
                    <span>{aCommand}</span>
                    : <span>{msg}<br />{aCommand}</span>
                )

            } else {
                if (active) {
                    let val = resolve(col.property, d)
                    aCommand = (<button type="button" className="btn-link"
                        onClick={function onClick(e) {
                            return cmdHandler(e, index, colindex, d);
                        }} dangerouslySetInnerHTML={setInnerHTML(val)}></button>)
                }
                else {
                    let val = resolve(col.property, d)
                    aCommand = (<span dangerouslySetInnerHTML={setInnerHTML(val)}></span>)
                }
                return (!msg ?
                    <span>{aCommand}</span>
                    : <span>{msg}<br />{aCommand}</span>
                )
            }
        } else {
            if (typeof cellStyler === "function" || typeof cellClasser === "function") {
                var cellStyle = {};
                if (typeof cellStyler === "function") {
                    cellStyle = cellStyler(d, col);
                }
                var cellClass = "";
                if (typeof cellClasser === "function") {
                    cellClass = cellClasser(d, col);
                }
                let val = resolve(col.property, d)
                return (!msg ?
                    <span style={cellStyle} className={cellClass} dangerouslySetInnerHTML={setInnerHTML(val)}></span>
                    : <span><span style={cellStyle} className={cellClass} dangerouslySetInnerHTML={setInnerHTML(val)}></span>{msg}</span>
                )
            }
            else {
                //types
                if (col.type === "dropdown") {
                    let val = resolve(col.property, d)

                    return (<AUselect
                        options={val}
                        value={d[col.default]}
                        onChange={(e) => col.onChange(e.target.options.selectedIndex, d)}
                        onBlur={(e) => col.onChange(e.target.options.selectedIndex, d)}
                    />)
                }
                
                else {
                    let val = resolve(col.property, d)
                    return (!msg ?
                        <span dangerouslySetInnerHTML={setInnerHTML(val)}></span>
                        : <span><span dangerouslySetInnerHTML={setInnerHTML(val)}></span>{msg}</span>
                    )
                }
            }
        }
    }

    const resolve = (path, obj = self, separator = '.') => {
        var properties = Array.isArray(path) ? path : path.split(separator)
        return properties.reduce((prev, curr) => prev && prev[curr], obj)
    }

    const captionRender = () => {
        let tableCaption = null;
        if (!stringIsNullOrEmpty(caption)) {

            if (subcaption) {
                tableCaption = (
                    <caption className="au-table__caption" style={{ captionSide: 'top' }}>
                        {caption}
                        <br />
                        <p className="h5"
                            dangerouslySetInnerHTML={setInnerHTML(subcaption)}>
                        </p>
                    </caption>
                )
            } else {
                tableCaption = (
                    <caption className="au-table__caption" style={{ captionSide: 'top' }} dangerouslySetInnerHTML={setInnerHTML(caption)}>
                    </caption>
                )
            }
        }

        return tableCaption;
    }

    const sortHandler = (property, type, e) => {
        e.preventDefault();
        if (handleRequestSort) {
            return handleRequestSort(property, type);
        }
    };

    const sortLabelrender = () => {
        const titleStyle = {
            marginLeft: '.2rem'
        };

        let button;

        return (
            cols.map((col, index) => {

                if(ignoreSortByColumn){
                    
                    button = (<th key={index} width={col.width} style={{marginLeft: '.2rem', fontWeight: 'bold'}} className="au-table__header casa-sort-header">{col.label}</th>)

                    if (!col.visible) {
                        button = (<th key={index} />);
                    }

                    return button;
                }
                if (!active) {

                    button = (<th key={index} width={col.width} onClick={(e) => sortHandler(col.property, col, e)}><button type="button" style={titleStyle} className="btn-link au-table__header casa-sort-header" dangerouslySetInnerHTML={setInnerHTML(col.label)} /></th>)

                    if (!col.visible) {
                        button = (<th key={index} />);
                    }

                    return button;
                }
                else {
                    if (active === col.property) {
                        if (sortOrder === "asc") {
                            button = (<th key={index} width={col.width} onClick={(e) => sortHandler(col.property, col, e)}><button type="button" style={titleStyle} className="au-table__header casa-sort-header-sorted-asc btn-link" dangerouslySetInnerHTML={setInnerHTML(col.label)} /></th>)
                        } else {
                            button = (<th key={index} width={col.width} onClick={(e) => sortHandler(col.property, col, e)}><button type="button" style={titleStyle} className="au-table__header casa-sort-header-sorted-desc btn-link" dangerouslySetInnerHTML={setInnerHTML(col.label)} /></th>)
                        }
                    } else {
                        button = (<th key={index} width={col.width} onClick={(e) => sortHandler(col.property, col, e)}><button type="button" style={titleStyle} className="btn-link au-table__header casa-sort-header" dangerouslySetInnerHTML={setInnerHTML(col.label)} /></th>)
                    }

                    if (!col.visible) {
                        button = (<th key={index} />);
                    }

                    return button;

                }

            })
        )
    }

    const headerRender = () => {

        return (
            <thead className="au-table__head">
                <tr className="au-table__row">
                    {sortLabelrender()}
                </tr>
            </thead>
        )
    }

    const showEmptyRow = () => {
        return (
            <tbody className="au-table__body">
                <tr>
                    {cols.map((d, colindex) => {
                        return (<td key={colindex} className="au-table__cell" style={{ display: colVisible(colindex) ? '' : 'none' }} > - </td>)
                    })}
                </tr>
            </tbody>)
    }

    const bodyRender = () => {
        if (showIfEmpty && data.length === 0) {
            return showEmptyRow();
        }

        return (
            <tbody className="au-table__body">
                {
                    !active ?
                        data.map((d, index) => {
                            return (
                                <tr className="au-table__row" key={index}>
                                    {cols.map((col, colindex) => {
                                        return colindex === 0
                                            ? (<td key={colindex} className="au-table__cell" style={{ display: colVisible(colindex) ? '' : 'none' }} >
                                                {
                                                    cellRender(col, colindex, d, index)
                                                }
                                            </td>)
                                            : (<td key={colindex} className="au-table__cell" align="right" style={{ display: colVisible(colindex) ? '' : 'none' }} >
                                                {
                                                    cellRender(col, colindex, d, index)
                                                }
                                            </td>
                                            )
                                    })}
                                </tr>
                            )
                        })
                        :
                        stableSort(data,
                            getSorting(sortOrder, active,
                                cols.find(x => x.property === active).type
                            )
                        ).map((d, index) => {
                            return (
                                <tr className="au-table__row" key={index} >
                                    {cols.map((col, colindex) => {
                                        return colindex === 0
                                            ? (<td key={colindex} className="au-table__cell" style={{ display: colVisible(colindex) ? '' : 'none' }} >
                                                {
                                                    cellRender(col, colindex, d, index)
                                                }
                                            </td>)
                                            : (<td key={colindex} className="au-table__cell" align="right" style={{ display: colVisible(colindex) ? '' : 'none' }} >
                                                {
                                                    cellRender(col, colindex, d, index)
                                                }
                                            </td>
                                            )
                                    })}
                                </tr>
                            )
                        })
                }
            </tbody>
        )
    }

    return (

        <table className="au-table au-table--striped casa-sort-table">

            {captionRender()}

            {headerRender()}

            {bodyRender()}

            {footer ? <tfoot className="au-table__head" >{footer()}</tfoot>: null}
        </table>

    )
}

SortedTable.propTypes = {
    order: PropTypes.oneOf(['asc', 'desc']),
    caption: PropTypes.string,
    subcaption: PropTypes.string,
    sortby: PropTypes.string,
    data: PropTypes.array.isRequired,
    cols: PropTypes.array.isRequired,
    showIfEmpty: PropTypes.bool,
    cellStyler: PropTypes.func,
    cellClasser: PropTypes.func,
    footer: PropTypes.func,
    ignoreSortByColumn: PropTypes.bool
};

export default SortedTable;